// Builds a multipart FormData body for a resource that has an image gallery.
//
//   buildImageFormData("project", { name: "X" }, {
//     files: [File, File], removeIds: [3, 4],
//     fileKey: "images", removeKey: "remove_image_ids",
//   })
//
// Produces: project[name]=X, images[]=<file>, images[]=<file>, remove_image_ids[]=3 …
// Scalar object/array values are JSON-encoded so Rails parses them as nested params.
export function buildImageFormData(
  resource,
  payload = {},
  { files = [], removeIds = [], fileKey = "images", removeKey = "remove_image_ids" } = {}
) {
  const form = new FormData()

  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return
    if (Array.isArray(value)) {
      if (value.length === 0) {
        form.append(`${resource}[${key}][]`, "")
      } else {
        value.forEach((v) => form.append(`${resource}[${key}][]`, v))
      }
    } else if (typeof value === "boolean") {
      form.append(`${resource}[${key}]`, value ? "true" : "false")
    } else if (typeof value === "object") {
      // Nested object (e.g. website_content block tree). JSON-encode it under a
      // sibling `<key>_json` field so the server can parse it back to a hash;
      // multipart can't carry an arbitrarily-nested object natively.
      form.append(`${resource}[${key}_json]`, JSON.stringify(value))
    } else {
      form.append(`${resource}[${key}]`, value)
    }
  })

  files.forEach((file) => form.append(`${fileKey}[]`, file))
  removeIds.forEach((id) => form.append(`${removeKey}[]`, id))

  return form
}

// True when an image change is present and the request must go multipart.
export function hasImageChanges({ files = [], removeIds = [] } = {}) {
  return files.length > 0 || removeIds.length > 0
}
